import { InboxStore } from "@/services/stores/types";
import { StateCreator } from "zustand";

export const inboxStore: StateCreator<InboxStore> = set => ({
  activeInboxItem: null,
  setActiveInboxItem: activeInboxItem =>
    set(state => ({
      ...state,
      activeInboxItem,
    })),
});
